"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var pax_1 = require("./pax");
function SET_FIELD(state, key) {
    var pax = state.paxe[key.index];
    var field = pax[key.name];
    field.error = key.error;
    field.errorShort = key.errorShort;
    field.touched = true;
    field.valid = key.valid;
    field.value = key.value;
    field.warning = key.warning;
    pax[key.name] = field;
    var paxe = [];
    paxe = paxe.concat(state.paxe);
    paxe[key.index] = pax;
    state.paxe = paxe;
}
exports.SET_FIELD = SET_FIELD;
function UNSET_TOUCHED(state, params) {
    var pax = state.paxe[params.key];
    var field = pax[params.name];
    field.error = null;
    field.errorShort = null;
    field.touched = false;
    field.valid = false;
    field.value = null;
    field.warning = null;
    pax[params.name] = field;
    var paxe = [];
    paxe = paxe.concat(state.paxe);
    paxe[params.key] = pax;
    state.paxe = paxe;
}
exports.UNSET_TOUCHED = UNSET_TOUCHED;
function SET_ERP_INFO(state, params) {
    var pax = state.paxe[params.key];
    pax.erpInfo = params.info;
}
exports.SET_ERP_INFO = SET_ERP_INFO;
function SET_ERP_INFOS(state, params) {
    var pax = state.paxe[params.key];
    pax.erpInfos = params.infos;
}
exports.SET_ERP_INFOS = SET_ERP_INFOS;
function SET_DEPARTURE_DATE(state, departureDate) {
    state.departureDate = departureDate;
}
exports.SET_DEPARTURE_DATE = SET_DEPARTURE_DATE;
function INC_PAX(state) {
    state.paxe.push(new pax_1.PaxElement(false));
}
exports.INC_PAX = INC_PAX;
function DEC_PAX(state) {
    if (lodash_1.last(state.paxe).isBuyer) {
        state.paxe[0].isBuyer = true;
    }
    if (state.paxe.length > 1) {
        state.paxe.pop();
    }
}
exports.DEC_PAX = DEC_PAX;
function SET_VALID(state, valid) {
    state.allFieldsValid = valid;
}
exports.SET_VALID = SET_VALID;
function IMPORT_FORM_VALIDATIONS(state, formValidations) {
    state.formValidations = lodash_1.cloneDeep(formValidations);
}
exports.IMPORT_FORM_VALIDATIONS = IMPORT_FORM_VALIDATIONS;
function SET_BUYER(state, index) {
    if (index < 0 || index >= state.paxe.length) {
        return;
    }
    for (var i = 0; i < state.paxe.length; i++) {
        if (index === i) {
            state.paxe[i].isBuyer = true;
        }
        else {
            state.paxe[i].isBuyer = false;
        }
    }
}
exports.SET_BUYER = SET_BUYER;
function UNSET_BUYER(state) {
    for (var i = 0; i < state.paxe.length; i++) {
        state.paxe[i].isBuyer = false;
    }
}
exports.UNSET_BUYER = UNSET_BUYER;
function SET_TRANSPORTATION_TYPE(state, type) {
    state.transportationType = type;
}
exports.SET_TRANSPORTATION_TYPE = SET_TRANSPORTATION_TYPE;
function SET_CHECK_PAX_CHILD_AGE(state, check) {
    state.checkPaxChildAge = check;
}
exports.SET_CHECK_PAX_CHILD_AGE = SET_CHECK_PAX_CHILD_AGE;
function SORT(state) {
    var paxSortValue = function (pax) { return moment_1.utc(pax.birthday.value, 'DD.MM.YYYY').unix(); };
    state.paxe.sort(function (a, b) { return paxSortValue(a) - paxSortValue(b); });
}
exports.SORT = SORT;
function RESET_STATE(state) {
    state.allFieldsValid = false;
    state.departureDate = '';
    state.formValidations = {};
    state.paxe = [new pax_1.PaxElement(true), new pax_1.PaxElement(false)];
    state.transportationType = '';
    state.checkPaxChildAge = false;
}
exports.RESET_STATE = RESET_STATE;
exports.default = {
    DEC_PAX: DEC_PAX,
    IMPORT_FORM_VALIDATIONS: IMPORT_FORM_VALIDATIONS,
    INC_PAX: INC_PAX,
    SET_BUYER: SET_BUYER,
    SET_ERP_INFO: SET_ERP_INFO,
    SET_ERP_INFOS: SET_ERP_INFOS,
    SET_FIELD: SET_FIELD,
    SET_VALID: SET_VALID,
    SET_DEPARTURE_DATE: SET_DEPARTURE_DATE,
    SET_TRANSPORTATION_TYPE: SET_TRANSPORTATION_TYPE,
    SET_CHECK_PAX_CHILD_AGE: SET_CHECK_PAX_CHILD_AGE,
    SORT: SORT,
    RESET_STATE: RESET_STATE,
    UNSET_BUYER: UNSET_BUYER,
    UNSET_TOUCHED: UNSET_TOUCHED,
};
//# sourceMappingURL=mutations.js.map